





































import FieldData from "@/components/infrastructures/functions/fieldData";
import httpResource from "@/components/infrastructures/functions/http/httpResource";
import {Component, Vue, Watch} from "vue-property-decorator";
import KawaiiButton from "@/components/infrastructures/atoms/KawaiiButton.vue";
import KawaiiDialog from "@/components/infrastructures/atoms/KawaiiDialog.vue";

@Component({
  components: {KawaiiDialog, KawaiiButton}
})
export default class DMVUploadTab extends Vue {

  name = "DMVUploadTab";

  // dialog
  dialog = false;
  dialogMessage = "";

  // register
  selectedDMVName = "";
  selectedDMVBin = "";
  disabledUpload = true;

  txtDMVName = new FieldData()
      .withType("text_field")
      .withRequires(true)
      .withLabel("DMV ファイル名");
  slctExpCluster = new FieldData()
      .withType("select")
      .withRequires(true)
      .withSelection([
        {text: "Type I", value: 1},
        {text: "Type II", value: 2},
        {text: "Type III", value: 3},
        {text: "Type IV", value: 4}
      ]);
  slctEstheMinutesCourse = new FieldData()
      .withType("select")
      .withRequires(true)
      .withSelection([
        {text: "10分コース", value: 1},
        {text: "20分コース", value: 2}
      ]);
  btnSelectedDMV = new FieldData()
      .withType("button")
      .withClickAction(this.openFileSelector)
      .withLabel("DMV 選択");

  selected() {
    const file = (this.$refs.input as any).files[0];

    this.selectedDMVName = file.name;
    if (this.txtDMVName.value === "") {
      this.txtDMVName.value = this.selectedDMVName;
    }

    const reader = new FileReader();
    reader.onload = (evt: any) => {
      this.selectedDMVBin = evt.target.result;
    }
    reader.readAsDataURL(file)
  }

  openFileSelector() {
    (this.$refs.input as any).click();
  }

  validate(): boolean {
    this.disabledUpload =
        this.selectedDMVBin === ""
        // || this.txtDMVName.value === ""
        || this.slctEstheMinutesCourse.value === ""
        || this.slctExpCluster.value === "";

    return !this.disabledUpload;
  }

  upload() {

    if (!this.validate()) {
      return;
    }

    const data = {
      title: this.txtDMVName.value,
      faceExpCluster: this.slctExpCluster.value,
      minutesCourse: this.slctEstheMinutesCourse.value,
      fileName: this.selectedDMVName,
      dmv: this.selectedDMVBin
    };

    this.disabledUpload = true;

    httpResource.post("/upload/aiesthe-dmv", data)
        .then((response: any) => {
          this.dialogMessage = "正常に登録できました。"
        })
        .catch((error: any) => {
          this.dialogMessage = "登録に失敗しました。"
        })
        .finally(() => {
          this.dialog = true;
          this.validate();
        });

  }

  @Watch("selectedDMVBin")
  watchSelectedDMV() {
    this.validate();
  }

  @Watch("slctExpCluster.value")
  watchSlctExpCluster() {
    this.validate();
  }

  @Watch("slctEstheMinutesCourse.value")
  watchSlctEstheMinutesCourse() {
    this.validate();
  }
}
